import { render } from "./LeaveListTable.vue?vue&type=template&id=251469ca&scoped=true"
import script from "./LeaveListTable.vue?vue&type=script&lang=js"
export * from "./LeaveListTable.vue?vue&type=script&lang=js"

import "./LeaveListTable.vue?vue&type=style&index=0&id=251469ca&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251469ca"]])

export default __exports__